module.exports = __webpack_public_path__ + "static/media/mobileSecondRail@3xOld.525a8dc9.png";